import { scholarships, WHATSAPP_URL } from '../data/siteData';
import { PageHero, CTASection } from '../components/UI';
import { useState } from 'react';

export default function Scholarships({ setPage }) {
  const [filter, setFilter] = useState('all');
  const filtered = filter === 'all' ? scholarships : scholarships.filter(s => s.type === filter);

  return (
    <div>
      <PageHero breadcrumb="Scholarships" title="Scholarship Guidance" subtitle="We identify real, achievable scholarships for your profile and help you submit applications that stand out. Many of our students study with partial to full funding." />

      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Filter */}
          <div className="flex gap-3 flex-wrap mb-10">
            {[{ v: 'all', l: 'All Scholarships' }, { v: 'full', l: 'Full Funding' }, { v: 'partial', l: 'Partial Funding' }].map(({ v, l }) => (
              <button key={v} onClick={() => setFilter(v)}
                className={`text-sm font-semibold px-4 py-2 rounded-full border transition-all duration-200 ${filter === v ? 'bg-teal/12 border-teal text-teal' : 'bg-white border-gray-200 text-gray-500 hover:border-teal/40 hover:text-teal'}`}>{l}</button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map(s => (
              <div key={s.name} className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:border-teal/40 hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="px-5 pt-5 flex items-start justify-between gap-3">
                  <span className="text-3xl">{s.flag}</span>
                  <span className={`text-[0.65rem] font-bold tracking-wide uppercase px-2.5 py-1 rounded-full ${s.type === 'full' ? 'bg-teal/15 text-teal' : 'bg-teal/8 text-gray-500'}`}>
                    {s.type === 'full' ? 'Full Funding' : 'Partial Funding'}
                  </span>
                </div>
                <div className="p-5">
                  <h4 className="font-body font-bold text-navy text-base mb-1">{s.name}</h4>
                  <div className="text-xs font-semibold text-teal mb-3">{s.country}</div>
                  <p className="text-gray-400 text-xs italic leading-relaxed mb-4">{s.value}</p>
                  <div className="flex flex-col gap-2 mb-4">
                    {s.steps.map((step, i) => (
                      <div key={i} className="flex gap-2.5 items-start">
                        <div className="w-5 h-5 rounded-full bg-teal/10 border border-teal/25 flex items-center justify-center text-[0.6rem] font-bold text-teal flex-shrink-0 mt-0.5">{i+1}</div>
                        <span className="text-xs text-gray-500 leading-relaxed">{step}</span>
                      </div>
                    ))}
                  </div>
                  <div className="text-[0.7rem] font-semibold text-gray-400 pt-3 border-t border-gray-100">
                    Deadline: <span className="text-teal">{s.deadline}</span>
                  </div>
                  <a href={`${WHATSAPP_URL}?text=Hi, I want guidance on the ${encodeURIComponent(s.name)} Scholarship`} target="_blank" rel="noreferrer"
                    className="inline-flex items-center gap-1.5 text-xs font-bold text-teal mt-3 hover:gap-2.5 transition-all">
                    Apply with Guidance →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection title="Not Sure Which Scholarship to Apply For?" subtitle="Our counselors will match your profile to the scholarships you actually qualify for — and help you submit a winning application." setPage={setPage} />
    </div>
  );
}
